/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateOrUpdateMileageRatesParams,
  CreateOrUpdateMileageRatesPayload,
  GetMileageRateListParams,
  GetMileageRateParams,
  GetMileageRateSnapshotParams,
  LegalRatesConfiguredDto,
  MileageRateDto,
  MileageRateListDto,
  MileageRateQuery,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiMileageRateController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-mileage-rate-controller
   * @name CreateOrUpdateMileageRates
   * @request POST:/api/v1/reimbursement/rates/mileage
   */
  createOrUpdateMileageRates = (
    query: CreateOrUpdateMileageRatesParams,
    data: CreateOrUpdateMileageRatesPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<MileageRateDto[], any>({
      path: `/v1/reimbursement/rates/mileage`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createOrUpdateMileageRatesPath = '/v1/reimbursement/rates/mileage'
  static createOrUpdateMileageRatesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-mileage-rate-controller
   * @name GetMileageRateList
   * @request POST:/api/v1/reimbursement/rates/mileage/list
   */
  getMileageRateList = (
    query: GetMileageRateListParams,
    data: MileageRateQuery,
    params: RequestParams = {},
  ) =>
    this.http.request<MileageRateListDto, any>({
      path: `/v1/reimbursement/rates/mileage/list`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getMileageRateListPath = '/v1/reimbursement/rates/mileage/list'
  static getMileageRateListMethod = 'POST'
  /**
   * No description
   *
   * @tags api-mileage-rate-controller
   * @name GetMileageRate
   * @request GET:/api/v1/reimbursement/rates/mileage/{id}
   */
  getMileageRate = ({ id, ...query }: GetMileageRateParams, params: RequestParams = {}) =>
    this.http.request<MileageRateDto, any>({
      path: `/v1/reimbursement/rates/mileage/${id}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getMileageRatePath = '/v1/reimbursement/rates/mileage/${id}'
  static getMileageRateMethod = 'GET'
  /**
   * No description
   *
   * @tags api-mileage-rate-controller
   * @name GetMileageRateSnapshot
   * @request GET:/api/v1/reimbursement/rates/mileage/{id}/v/{version}
   */
  getMileageRateSnapshot = (
    { id, version, ...query }: GetMileageRateSnapshotParams,
    params: RequestParams = {},
  ) =>
    this.http.request<MileageRateDto, any>({
      path: `/v1/reimbursement/rates/mileage/${id}/v/${version}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getMileageRateSnapshotPath = '/v1/reimbursement/rates/mileage/${id}/v/${version}'
  static getMileageRateSnapshotMethod = 'GET'
  /**
   * No description
   *
   * @tags api-mileage-rate-controller
   * @name AreLegalRatesConfigured
   * @request GET:/api/v1/reimbursement/rates/mileage/check-legal-rates-configuration
   */
  areLegalRatesConfigured = (params: RequestParams = {}) =>
    this.http.request<LegalRatesConfiguredDto, any>({
      path: `/v1/reimbursement/rates/mileage/check-legal-rates-configuration`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static areLegalRatesConfiguredPath =
    '/v1/reimbursement/rates/mileage/check-legal-rates-configuration'
  static areLegalRatesConfiguredMethod = 'GET'
}
